import React, {useRef} from "react";
import {BootstrapTable, SizePerPageDropDown, TableHeaderColumn} from "react-bootstrap-table";
import {Badge, Button, Col, OverlayTrigger, Row, Tooltip} from "react-bootstrap";
import moment from "moment";
import Dollars, {dollar} from "../../../../components/Dollars";
import {defaultDateTimeFormat} from "../../../../common/commonHandlers";
import StripeIDsFormatter from "./StripeIdsFormatter";
import {useMediaQuery} from '../../../../utilities/hooks/useMediaQuery';

const AdminTransactionsTable = ({
                                    transactions,
                                    tableParams,
                                    total,
                                    onPageChange,
                                    onSortChange,
                                    refreshStripeTransactions,
                                    onSelect,
                                    onSelectAll,
                                    rowSelected
                                }) => {
    const isMobile = useMediaQuery(991);
    const scrollRef = useRef(null)

    const renderSizePerPageDropDown = () => {
        return (
            <SizePerPageDropDown
                className='my-size-per-page'
                variation='dropup'
                onClick={() => {
                }}
                currSizePerPage={tableParams.per_page}
            />
        );
    };

    const dateFormat = (date) => moment.unix(date).format(defaultDateTimeFormat)

    const mobileFormatter = (cell, row) => {
        const details = row.fee_details && JSON.parse(row.fee_details)

        return <Row className="text-left">
            <Col xs={12}>{valueFormatter(cell, row)}</Col>
            <Col xs={12} className="d-flex">
                <div className="mr-3" style={{textWrap: 'nowrap'}}>Currency:</div>
                <div className="bold">{currencyFormatter(cell, row)}</div>
            </Col>
            <Col xs={12} className="d-flex">
                <div className="mr-3" style={{textWrap: 'nowrap'}}>Created:</div>
                <div className="bold">{dateFormat(row.created)}</div>
            </Col>
            <Col xs={12} className="d-flex">
                <div className="mr-3" style={{textWrap: 'nowrap'}}>Available On:</div>
                <div className="bold">{dateFormat(row.available_on)}</div>
            </Col>
            <Col xs={12} className="d-flex">
                <div className="mr-3" style={{textWrap: 'nowrap'}}>Exchange Rate:</div>
                <div className="bold">{row.exchange_rate ? row.exchange_rate : <span>N/A</span>}</div>
            </Col>
            <Col xs={12} className="d-flex">
                <div className="mr-3" style={{textWrap: 'nowrap'}}>Transaction Type:</div>
                <div className="bold">{row.stripe_transaction_type ? row.stripe_transaction_type :
                    <span>N/A</span>}</div>
            </Col>
            <Col xs={12} className="d-flex">
                <div className="mr-3" style={{textWrap: 'nowrap'}}>Status:</div>
                <div className="bold">{row.status ? row.status : <span>N/A</span>}</div>
            </Col>
            <Col xs={12} className="d-flex">
                <div className="mr-3" style={{textWrap: 'nowrap'}}>Object:</div>
                <div className="bold">{row.object ? row.object : <span>N/A</span>}</div>
            </Col>
            <Col xs={12} className="d-flex">
                <div className="mr-3" style={{textWrap: 'nowrap'}}>Reporting Category:</div>
                <div className="bold">{row.reporting_category ? row.reporting_category : <span>N/A</span>}</div>
            </Col>
            <Col xs={12} className="d-flex">
                <div className="mr-3" style={{textWrap: 'nowrap'}}>Invoice:</div>
                <div className="bold">{invoiceFormatter(cell, row)}</div>
            </Col>
            <Col xs={12} className="d-flex">
                <div className="mr-3" style={{textWrap: 'nowrap'}}>Customer:</div>
                <div className="bold">{customerFormatter(cell, row)}</div>
            </Col>
            <Col xs={12} className="d-flex">
                <div className="mr-3" style={{textWrap: 'nowrap'}}>Client:</div>
                <div className="bold">{row.client_name ? row.client_name : <span>N/A</span>}</div>
            </Col>
            <Col xs={12} className="d-flex">
                <div className="mr-3" style={{textWrap: 'nowrap'}}>Stripe ID:</div>
                <div className="bold">{row.stripe_id ? row.stripe_id : <span>N/A</span>}</div>
            </Col>
            <Col xs={12} className="d-flex">
                <div className="mr-3" style={{textWrap: 'nowrap'}}>Source ID:</div>
                <div className="bold">{row.source ? row.source : <span>N/A</span>}</div>
            </Col>
            <Col xs={12} className="d-flex">
                <div className="mr-3" style={{textWrap: 'nowrap'}}>Description:</div>
                <div className="bold">{row.description ? row.description : <span>N/A</span>}</div>
            </Col>
            <Col xs={12}>
                {details && details.length > 0 ?
                    <Row>
                        <Col xs={12} className="mr-3">Fee Details:</Col>
                        <Col xs={12} style={{paddingLeft: '50px'}}>
                            {details.map(detail => <>
                                <Row className="d-flex">
                                    <div className="mr-5" style={{textWrap: 'nowrap'}}>Amount:</div>
                                    <div className="bold"><Dollars amount={detail.amount}/></div>
                                </Row>
                                <Row className="d-flex">
                                    <div className="mr-5" style={{textWrap: 'nowrap'}}>Application:</div>
                                    <div className="bold">{detail.application ? detail.application :
                                        <span>N/A</span>}</div>
                                </Row>
                                <Row className="d-flex">
                                    <div className="mr-5" style={{textWrap: 'nowrap'}}>Currency:</div>
                                    <div className="bold">{currencyFormatter(detail.currency)}</div>
                                </Row>
                                <Row className="d-flex">
                                    <div className="mr-5" style={{textWrap: 'nowrap'}}>Description:</div>
                                    <div className="bold">{detail.description}</div>
                                </Row>
                                <Row className="d-flex">
                                    <div className="mr-5" style={{textWrap: 'nowrap'}}>Type:</div>
                                    <div className="bold">{detail.type}</div>
                                </Row>
                            </>)}
                        </Col>
                    </Row>
                    :
                    <Row>
                        <Col xs={12} className="d-flex">
                            <div className="mr-3" style={{textWrap: 'nowrap'}}>Fee Details:</div>
                            <div className="bold"><span>N/A</span></div>
                        </Col>
                    </Row>
                }

            </Col>
            <Col xs={12} className="d-flex">
                <div className="mr-3" style={{textWrap: 'nowrap'}}>Actions:</div>
                <div className="bold">{row.stripe_id ? actionsFormatter(row.stripe_id) : <span>N/A</span>}</div>
            </Col>
        </Row>
    }

    const valueFormatter = (cell, row) => {
        const amount = row.amount / 100
        const fee = row.fee / 100
        const net = row.net / 100
        const valueColorStyle = (value) => value > 0 ? 'green' : value === 0 ? null : 'red';

        return <Row className="text-left">
            <Col xs={12}>
                <span className="mr-3">Amount:</span>
                <span style={{color: valueColorStyle(amount)}}><b><Dollars amount={amount}/></b></span>
            </Col>
            <Col xs={12}>
                <span className="mr-3">Fee:</span>
                <span style={{color: valueColorStyle(fee)}}><b><Dollars amount={fee}/></b></span>
            </Col>
            <Col xs={12}>
                <span className="mr-3">Net:</span>
                <span style={{color: valueColorStyle(net)}}><b><Dollars amount={net}/></b></span>
            </Col>
        </Row>
    };

    const dateFormatter = (cell, row) => {
        return <Row>
            <Col xs={12}>Created</Col>
            <Col xs={12} className="bold">{dateFormat(row.created)}</Col>
            <Col xs={12}>Available On</Col>
            <Col xs={12} className="bold">{dateFormat(row.available_on)}</Col>
        </Row>
    };

    const invoiceFormatter = (cell, row) => {
        return <span> {row.invoice_no ? `#${row.invoice_no}` : "N/A"}</span>
    }
    const customerFormatter = (cell, row) => {
        return <span> {row.customer_name ? row.customer_name : "N/A"}</span>
    }
    const currencyFormatter = (cell) => cell ? cell.toUpperCase() : <span>N/A</span>

    const detailFormatter = cell => {
        const details = JSON.parse(cell)

        return <OverlayTrigger
            placement="left"
            overlay={
                <Tooltip id="tooltip">
                    <div className="text-left">
                        {details && details.length > 0 ? details.map(detail => <>
                            <div>
                                <span className="mr-5">Amount:</span>
                                <span className="bold"><Dollars amount={detail.amount}/></span>
                            </div>
                            <div>
                                <span className="mr-5">Application:</span>
                                <span className="bold">{detail.application ? detail.application :
                                    <span>N/A</span>}</span>
                            </div>
                            <div>
                                <span className="mr-5">Currency:</span>
                                <span className="bold">{currencyFormatter(detail.currency)}</span>
                            </div>
                            <div>
                                <span className="mr-5">Description:</span>
                                <span className="bold">{detail.description}</span>
                            </div>
                            <div>
                                <span className="mr-5">Type:</span>
                                <span className="bold">{detail.type}</span>
                            </div>
                        </>) : 'No details'}
                    </div>
                </Tooltip>}>
            <Badge className="proposalBadge font12 pointer">{details ? details.length : 0}</Badge>
        </OverlayTrigger>
    }

    const stripeIDsFormatter = (cell, row) => {
        return <StripeIDsFormatter row={row} scrollContainerRef={scrollRef}/>
    }

    const csvValueFormatter = (cell) => dollar(+cell / 100)
    const csvDateFormatter = (cell) => dateFormat(cell)
    const csvCurrencyFormatter = (cell) => cell ? cell.toUpperCase() : 'N/A'
    const csvInvoiceFormatter = (cell) => cell ? `#${cell}` : 'N/A'
    const csvDetailFormatter = (cell) => cell ? cell.replace(/,/g, ';') : 'N/A'

    const actionsFormatter = (cell) => {
        return <Button
            bsSize="xsmall"
            bsStyle="success"
            onClick={() => refreshStripeTransactions([cell])}
        >
            Refresh
        </Button>
    }

    const column = (width, dataField, header, dataFormat = null, csvFormat = null) => {
        return <TableHeaderColumn
            width={`${width}%`}
            dataField={dataField}
            export={false}
            tdStyle={{wordBreak: "break-word", textAlign: "center"}}
            thStyle={{textAlign: "center"}}
            dataSort={true}
            dataFormat={dataFormat ? dataFormat : (cell) => cell ? cell : <span>N/A</span>}
            csvFormat={csvFormat ? csvFormat : cell => cell ? cell : 'N/A'}
            csvHeader={header}
        >
            {header}
        </TableHeaderColumn>
    }

    const exportColumn = (dataField, header, csvFormat = null) => {
        return <TableHeaderColumn
            width="10%"
            hidden
            export
            dataField={dataField}
            tdStyle={{wordBreak: "break-word", textAlign: "center"}}
            thStyle={{textAlign: "center"}}
            dataSort={true}
            csvFormat={csvFormat ? csvFormat : cell => cell ? cell : 'N/A'}
            csvHeader={header}
        >
            {header}
        </TableHeaderColumn>
    }

    const bootstrapTableParams = {
        data: transactions,
        striped: true,
        bordered: false,
        exportCSV: true,
        csvFileName: `stripe_transaction_${moment().format(defaultDateTimeFormat)}.csv`,
        hover: true,
        remote: true,
        fetchInfo: {dataTotalSize: total},
        pagination: transactions && transactions.length > 0,
        className: "wrapped",
        options: {
            sortName: tableParams.sort_by,
            sizePerPageDropDown: renderSizePerPageDropDown,
            sizePerPage: tableParams.per_page,
            sortOrder: tableParams.sort,
            page: tableParams.page,
            onPageChange: onPageChange,
            onSortChange: onSortChange,
            sizePerPageList: [
                {text: '10', value: 10},
                {text: '25', value: 25},
                {text: '30', value: 30},
                {text: '50', value: 50},
                {text: '100', value: 100},
                {text: '200', value: 200},
                {text: 'All', value: total},
            ],
            onExportToCSV: () => {
                return transactions.filter(tx => rowSelected.includes(tx.id))
            },
        },
        selectRow: {
            mode: "checkbox",
            clickToSelect: false,
            selected: rowSelected,
            onSelect: onSelect,
            onSelectAll: onSelectAll
        }
    }

    return <div className="transaction-table-wrapper"
                ref={scrollRef}>
        {isMobile ?
            <BootstrapTable
                {...bootstrapTableParams}
            >
                <TableHeaderColumn
                    dataField="id"
                    hidden
                    isKey={true}
                />
                {column(100, "Created", "Transactions", mobileFormatter)}
                {exportColumn("amount", "Amount", csvValueFormatter)}
                {exportColumn('fee', 'Fee', csvValueFormatter)}
                {exportColumn('net', 'Net', csvValueFormatter)}
                {exportColumn("created", "Created", csvDateFormatter)}
                {exportColumn('available_on', 'Available On', csvDateFormatter)}
                {exportColumn("exchange_rate", "Exchange Rate")}
                {exportColumn("currency", "Currency", csvCurrencyFormatter)}
                {exportColumn("stripe_transaction_type", "Transaction Type")}
                {exportColumn("status", "Status")}
                {exportColumn("object", "Object")}
                {exportColumn("reporting_category", "Reporting Category")}
                {exportColumn("invoice_no", "Invoice", csvInvoiceFormatter)}
                {exportColumn("customer_name", "Customer")}
                {exportColumn("client_name", "Client")}
                {exportColumn("description", "Description")}
                {exportColumn("fee_details", "Fee Details", csvDetailFormatter)}
                {exportColumn("stripe_id", "Stripe ID")}
                {exportColumn("source", "Source ID")}
            </BootstrapTable>
            :
            <BootstrapTable
                {...bootstrapTableParams}
            >
                <TableHeaderColumn
                    dataField="id"
                    hidden
                    isKey={true}
                />
                {column(16, "amount", "Amount", valueFormatter)}
                {column(16, "created", "Created", dateFormatter)}
                {column(13, "exchange_rate", "Exchange Rate")}
                {column(10, "currency", "Currency", currencyFormatter)}
                {column(12, "stripe_transaction_type", "Transaction Type")}
                {column(10, "status", "Status")}
                {column(10, "object", "Object")}
                {column(10, "reporting_category", "Reporting Category")}
                {column(10, "invoice_no", "Invoice", invoiceFormatter)}
                {column(11, "customer_name", "Customer", customerFormatter)}
                {column(10, "client_name", "Client")}
                {column(30, "description", "Description")}
                {column(12, "fee_details", "Fee Details", detailFormatter)}
                {column(10, "stripe_id", "Stripe IDs", stripeIDsFormatter)}
                {column(12, "stripe_id", "Actions", actionsFormatter)}
                {exportColumn("amount", "Amount", csvValueFormatter)}
                {exportColumn('fee', 'Fee', csvValueFormatter)}
                {exportColumn('net', 'Net', csvValueFormatter)}
                {exportColumn("created", "Created", csvDateFormatter)}
                {exportColumn('available_on', 'Available On', csvDateFormatter)}
                {exportColumn("exchange_rate", "Exchange Rate")}
                {exportColumn("currency", "Currency", csvCurrencyFormatter)}
                {exportColumn("stripe_transaction_type", "Transaction Type")}
                {exportColumn("status", "Status")}
                {exportColumn("object", "Object")}
                {exportColumn("reporting_category", "Reporting Category")}
                {exportColumn("invoice_no", "Invoice", csvInvoiceFormatter)}
                {exportColumn("customer_name", "Customer")}
                {exportColumn("client_name", "Client")}
                {exportColumn("description", "Description")}
                {exportColumn("fee_details", "Fee Details", csvDetailFormatter)}
                {exportColumn("stripe_id", "Stripe ID")}
                {exportColumn("source", "Source ID")}
            </BootstrapTable>
        }
    </div>
}

export default AdminTransactionsTable;